import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ErrorMessage from '../_components/ErrorMessage';
import { BusinessProfileActions } from '../_actions';
import { ModalCreateNews_VALIDATIONS } from '../_validations/modalValidations';
import clip from '../_assets/imgs/clip.png';
import { ToastContainer, toast } from 'react-toastify';

function ModalCreateNews({ handleClose, show }) {
  const dispatch = useDispatch();
  const registering = useSelector(
    (state) => state.businessProfileReducers.isLoadingModal
  );
  const [tmpFile, setFile] = useState(null);
  const formSchema = Yup.object().shape({ ...ModalCreateNews_VALIDATIONS });
  const validationOpt = {
    resolver: yupResolver(formSchema),
  };
  const { register, handleSubmit, reset, formState } = useForm(validationOpt);
  const { errors } = formState;

  function onFormSubmit(data) {
    dispatch(BusinessProfileActions.CreateNews(data, reset, toast));
  }

  function handleChange(selectorFiles) {
    setFile(selectorFiles[0]);
  }

  function resetForm() {
    handleClose();
  }

  return (
    <>
      <ToastContainer autoClose={false} theme="colored" />
      <Modal show={show} onHide={handleClose} className="modal-filters">
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="text-center">Nueva noticia</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
              <div className="row">
                <div className="">
                  <div
                    className={
                      'form-group half-minus-10-right' +
                      (errors.title ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="title">Título de la foto</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      disabled={registering}
                      {...register('title')}
                      placeholder="Título de la foto"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.title} />
                  </div>
                  <div
                    className={
                      'form-group half-minus-10-left' +
                      (errors.subtitle ? ' has-error' : '')
                    }
                  >
                    <label htmlFor="subtitle">Subtítulo</label>
                    <input
                      type="text"
                      className="form-control"
                      name="subtitle"
                      disabled={registering}
                      {...register('subtitle')}
                      placeholder="Subtítulo"
                      autoComplete="off"
                    />
                    <ErrorMessage error={errors.subtitle} />
                  </div>
                </div>
                <div
                  className={
                    'form-group half-minus-10-right' +
                    (errors.image ? ' has-error' : '')
                  }
                >
                  <label
                    htmlFor="image"
                    className="custom-file-upload-rfc pointer"
                  >
                    <img src={clip} style={{ width: 'auto' }} alt="" />
                    {tmpFile ? tmpFile.name : 'Agrega una imagen'}
                    <input
                      id="image"
                      type="file"
                      name="image"
                      placeholder="subir"
                      accept="image/*"
                      disabled={registering}
                      {...register('image', {
                        onChange: (e) => handleChange(e.target.files),
                      })}
                    />
                  </label>
                  <ErrorMessage error={errors.image} />
                </div>
              </div>
              <div className="text-right buttons">
                <button
                  type="button"
                  className="btn btn-white-bg"
                  disabled={registering}
                  onClick={resetForm}
                >
                  Cancelar
                </button>
                <button className="btn btn-primary" disabled={registering}>
                  Añadir
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalCreateNews;
